import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';

import { sentryOptions } from '../constants/sentryOptions';
import { ErrorContext } from '../types/ErrorContext';
import { ErrorReporter } from '../types/ErrorReporter';

export const sentryErrorReporter: ErrorReporter = {
  captureException: (error, context?: ErrorContext): void => {
    Sentry.captureException(error, context);
  },

  init: (): void => {
    Sentry.init(sentryOptions);
  },

  setUser: (user: { id: string; email?: string }): void => {
    Sentry.setUser(user);
  },

  setAdditionalData: (data: Record<string, unknown>): void => {
    Sentry.setExtras(data);
  },

  wrapCreateBrowserRouter: (
    createRouter: typeof createBrowserRouter,
  ): typeof createBrowserRouter => {
    return Sentry.wrapCreateBrowserRouter(createRouter);
  },
};
